export default {
  data() {
    return {
      timer_interval: 250,
      timer_expected: null,
      timer_timeouts: [],
      timer_remaining: 90000,
      timer_end: null,
      timer_duration: null,
    };
  },

  methods: {
    timer_start(end, duration) {
      this.timer_end = end;
      this.timer_duration = duration;
      this.timer_expected = Date.now() + this.timer_interval;
      this.timer_timeouts.push(setTimeout(this.timer_step, this.timer_interval));
    },

    timer_stop() {
      for (let i = 0; i < this.timer_timeouts.length; i += 1) {
        clearTimeout(this.timer_timeouts[i]);
      }
    },

    timer_step() {
      const drift = Date.now() - this.timer_expected;
      const maxRemaining = Math.max(0, this.timer_end - Date.now());

      this.timer_remaining = Math.min(maxRemaining, this.timer_duration);

      if (this.timer_end <= Date.now()) {
        this.timer_stop();
      } else {
        this.timer_expected += this.timer_interval;
        this.timer_timeouts.push(setTimeout(
          this.timer_step,
          Math.max(0, this.timer_interval - drift),
        ));
      }
    },
  },
};
